import type { EquipQuality } from '@/types/equip'

export function getSynthesisPrice(quality?: EquipQuality) {
  switch (quality) {
    case 'unique':
      return 800
    case 'legend':
      return 1000
    case 'antiquity':
      return 100
    case 'myth':
      return 2000
    default:
      return 0
  }
}
